var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('slide-hero'),_c('slide-feature'),_c('slide-type'),_c('slide-package'),_c('slide-recommend'),_c('slide-material'),_c('slide-valiation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }